<template>
    <div>
        <div class="flex-body pb-2">
            <div>
                <div class="mx-auto d-flex flex-column justify-content-center">
                    <!-- Summary container -->
                    <div class="py-2">
                        <p class="lead text-semibold">
                            The following data was imported into payroll:
                        </p>
                        <!-- Big metrics -->
                        <div class="pb-4">
                            <div class="d-flex flex-wrap">
                                <div class="mr-8">
                                    <div class="text-display1">
                                        {{ this.taskDetail.payroll_summary_stats.total_employees_for_payroll }}
                                    </div>
                                    <div class="theading">
                                        Employees
                                    </div>
                                </div>
                                <div class="mr-8">
                                    <div class="text-display1">
                                        {{ this.taskDetail.payroll_summary_stats.total_hours_reg }}
                                    </div>
                                    <div class="theading">
                                        Regular Hours
                                    </div>
                                </div>
                                <div class="mr-8">
                                    <div class="text-display1">
                                        {{ this.taskDetail.payroll_summary_stats.total_hours_ot }}
                                    </div>
                                    <div class="theading">
                                        Overtime Hours
                                    </div>
                                </div>
                                <div class="mr-8" v-if="this.taskDetail.payroll_summary_stats.total_hours_other">
                                    <div class="text-display1">
                                        {{ this.taskDetail.payroll_summary_stats.total_hours_other }}
                                    </div>
                                    <div class="theading">
                                        Other Hours
                                    </div>
                                </div>
                                <div class="mr-8" v-if="otherEarningsTile">
                                    <div class="text-display1">
                                        ${{ otherEarningsTile.amount }}
                                    </div>
                                    <div class="theading">
                                        {{ otherEarningsTile.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END Summary container -->

                    <!-- New hires added -->
                    <div class="py-1" v-if="newHiresAdded.length">
                        <div class="table-section">
                            <a href class="table-section-titlebar collapse-trigger" role="button" :class="{'is-expanded': addedExpanded}" @click.prevent="addedExpanded = !addedExpanded">
                                <span class="widget-toggle-wrapper">
                                    <collapse-toggle-button />
                                </span>
                                <h5 class="table-section-title">
                                    New hires added <span class="text-regular">({{ newHiresAdded.length }})</span>
                                </h5>
                            </a>

                            <div class="collapse" :class="{'show': addedExpanded}">
                                <table class="table table-sm mt-1">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Company</th>
                                            <th>Store</th>
                                            <th>Hire date</th>
                                            <th class="text-right">Pay rate</th>
                                            <th>SSN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(person, idx) in newHiresAdded" :key="idx">
                                            <td>{{ person.name }}</td>
                                            <td>{{ person.company_name }}</td>
                                            <td>{{ person.store }}</td>
                                            <td>{{ person.date_hired }}</td>
                                            <td class="text-right">{{ person.pay_rate }}</td>
                                            <td>{{ person.ssn }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- END New hires added -->

                    <!-- Not imported -->
                    <div class="py-1" v-if="hasProblems">
                        <div class="table-section">
                            <a href class="table-section-titlebar collapse-trigger" role="button" :class="{'is-expanded': notImportedExpanded}" @click.prevent="notImportedExpanded = !notImportedExpanded">
                                <span class="widget-toggle-wrapper">
                                    <collapse-toggle-button />
                                </span>
                                <h5 class="table-section-title">
                                    Not imported <span class="text-regular">({{ notImported.length }})</span>
                                </h5>
                            </a>

                            <div class="collapse" :class="{'show': notImportedExpanded}">
                                <div class="py-2">
                                    <div class="tr-wrapper tr-hasissue issue-blocker p-2" v-for="(record, idx) in notImported" :key="idx">
                                        <div class="row row-alt">
                                            <div class="col-md-4">
                                                <h4 class="mb-0">{{ record.Name }}</h4>
                                                <div class="text-muted">
                                                    <span class="mr-1" v-if="record.Payroll_ID">{{ record.Payroll_ID }}</span>
                                                    <b v-if="record.Store">Store: {{ record.Store }}</b>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h4 class="mb-0">{{ record.title }}</h4>
                                                <div>{{ record.suggestion }}</div>
                                            </div>
                                            <div class="col-md-3 text-right">
                                                {{ record.Reg_Hrs }} Reg Hrs<br>
                                                {{ record.OT_Hrs }} OT Hrs
                                            </div>
                                        </div>
                                    </div>

                                    <a class="btn btn-outline-primary btn-sm mt-2" :href="downloadURL">
                                        <i class="far fa-fw fa-file-excel"></i> <span class="btn-text">Download errors</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END Not imported -->

                    <div class="mx-auto d-flex flex-column justify-content-center w-75 mb-4" v-if="this.taskDetail.errors_json">
                        <div v-for="error in this.taskDetail.errors_json">
                            <div class="alert alert-danger">
                                <h4>
                                    <i class="fas fa-fw fa-exclamation-triangle"></i> Error
                                </h4>

                                {{ error.description }}

                                <div v-if="error.referenced_data">
<br>
<pre>
<b>{{ error.referenced_data_header }}</b>{{ error.referenced_data }}
</pre>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- the server puts terminated employees first -->
                    <div class="mx-auto d-flex flex-column justify-content-center w-75 mb-4" v-if="this.taskDetail.warnings_json">
                        <div v-for="warning in this.taskDetail.warnings_json">
                            <div class="alert alert-warning">
                                <h4>
                                    <i class="fas fa-fw fa-exclamation-triangle"></i> Warning
                                </h4>

                                {{ warning.description }}

                                <div v-if="warning.referenced_data">
<br>
<pre>
<b>{{ warning.referenced_data_header }}</b>{{ warning.referenced_data }}
</pre>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="text-center">
                        <div class="icon-huge">
                            <i class="fas fa-check"></i>
                        </div>
                        <h1 class="mb-1">Import was successful.</h1>
                        <p class="mb-4">
                            Employee hours from POS are now in payroll.
                        </p>
                        <p>
                            <router-link class="btn btn-primary" :to="{name: 'employer-home', params: {hashedClientId: $hasher.encode(client.id)}}">Home</router-link>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import FastTable from '@/components/FastTable'

import moment from 'moment'

import { otherEarningsTile } from './tips'

export default {
    props: ['client', 'taskDetail'],
    components: {FastTable, },
    computed: {
        otherEarningsTile() {
            return otherEarningsTile(this.taskDetail)
        },
        newHiresAdded() {
            return this.taskDetail.new_hires_added || []
        },
        notImported() {
            return this.taskDetail.skipped_data_summary.skipped_records || []
        },
        hasProblems() {
            const messages = (this.taskDetail.errors_json || []).length + (this.taskDetail.warnings_json || []).length
            return this.notImported.length > 0 || messages > 0
        },
        downloadURL() {
            return `${this.$api.API_BASE}/clients/${this.client.id}/pos-integration/${this.$route.params.taskId}/warnings/download`
        },
    },
    data() {
        const companiesExpanded = {}

        for (const [key, value] of Object.entries(this.taskDetail.payroll_summary_by_company_location)) {
            companiesExpanded[value['CompanyCode']] = false
        }

        return {
            companiesExpanded: companiesExpanded,
            addedExpanded: false,
            notImportedExpanded: true,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Point-of-Sale Integration')
    },
    methods: {
    },
}
</script>
